module.exports = __webpack_public_path__ + "static/img/History.40ab651.png";